<template>
  <div class="operate">
    <div class="header">
      <div class="title">运营场景</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import operate1 from "../../../../assets/programme/operate1.png";
import operate2 from "../../../../assets/programme/operate2.png";
import operate3 from "../../../../assets/programme/operate3.png";
import operate4 from "../../../../assets/programme/operate4.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "远程操控  快速开启充电模式",
          text: "随时登录后台app，远程在线一键开启充电模式，方便快捷。",
          logo: operate1,
        },
        {
          id: 2,
          title: "充电进程信息提醒",
          text: "智能系统，自动判断充电状态，给业主发送充电进程信息，安全放心。",
          logo: operate2,
        },
        {
          id: 3,
          title: "余额提醒  预存充电",
          text: "余额一键查询，系统智能提醒，随时缴费充值，省时省力。",
          logo: operate3,
        },
        {
          id: 4,
          title: "智能结算  线上支付",
          text: "无需主动计算充电时长，系统后台自动结算，生成报表，实时查阅计费数据、账单明细，一键支付，透明省心。",
          logo: operate4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.operate {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  text-align: center;
  margin-bottom: 16px;
  border: 1px solid #d5e3fa;
  overflow: hidden;
}
.body .list .item img {
  width: 100%;
}
.body .list .item .title {
  color: #248efb;
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
.body .list .item .text {
  width: 311px;
  font-size: 12px;
  margin: 8px auto 16px;
  color: #495a6c;
}
</style>
